import { QueryFunction, useQuery } from '@tanstack/react-query';

import { useFetchWithAuth } from '../useFetchWithAuth';

export const useGetAlleEenheden = () => {
  const { fetchWithAuth } = useFetchWithAuth();

  const fetcher: QueryFunction<string[]> = async () => {
    const response = await fetchWithAuth('/stamgegevens/eenheidnummers');
    if (response.ok) return response.json();
    return [];
  };

  return useQuery({
    queryKey: ['useGetAlleEenheden'],
    queryFn: fetcher,
  });
};
